import { useState, useMemo } from 'react';

/**
 * usePagination - Sayfalama için yeniden kullanılabilir hook
 * 
 * @param {Array} data - Sayfalanacak veri dizisi
 * @param {number} pageSize - Sayfa başına öğe sayısı (varsayılan: 10)
 * @returns {Object} Sayfalama state ve fonksiyonları
 */
export default function usePagination(data = [], pageSize = 10) {
    const [currentPage, setCurrentPage] = useState(1);

    // Toplam sayfa sayısı
    const totalPages = Math.ceil(data.length / pageSize);

    // Mevcut sayfadaki veriler
    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return data.slice(startIndex, endIndex);
    }, [data, currentPage, pageSize]);

    // Sayfa değiştirme fonksiyonu
    const goToPage = (page) => {
        const validPage = Math.max(1, Math.min(page, totalPages));
        setCurrentPage(validPage);
    };

    // Sonraki sayfa
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    // Önceki sayfa
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    // İlk sayfaya git
    const firstPage = () => setCurrentPage(1);

    // Son sayfaya git
    const lastPage = () => setCurrentPage(totalPages);

    // Sayfa sıfırla (veri değiştiğinde)
    const resetPage = () => setCurrentPage(1);

    return {
        // State
        currentPage,
        totalPages,
        pageSize,
        totalItems: data.length,

        // Data
        paginatedData,

        // Navigation
        goToPage,
        nextPage,
        prevPage,
        firstPage,
        lastPage,
        resetPage,

        // Flags
        hasNextPage: currentPage < totalPages,
        hasPrevPage: currentPage > 1,
    };
}
